module.exports = __webpack_public_path__ + "img/1970East-013_WEB-min.99481141.jpg";